<div class="h-100 d-flex align-items-center justify-content-center">
  <img src="{{ imgUrl }}">
</div>
